module.exports = __webpack_public_path__ + "static/food-7c94d9b85473a965635d4fbf5f3fd42b.jpg";